/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { calculate } from '../fn/tunnel-section-controller/calculate';
import { Calculate$Params } from '../fn/tunnel-section-controller/calculate';
import { calculateAll } from '../fn/tunnel-section-controller/calculate-all';
import { CalculateAll$Params } from '../fn/tunnel-section-controller/calculate-all';
import { createTunnelSection } from '../fn/tunnel-section-controller/create-tunnel-section';
import { CreateTunnelSection$Params } from '../fn/tunnel-section-controller/create-tunnel-section';
import { deleteTunnelSection } from '../fn/tunnel-section-controller/delete-tunnel-section';
import { DeleteTunnelSection$Params } from '../fn/tunnel-section-controller/delete-tunnel-section';
import { getExcelFile } from '../fn/tunnel-section-controller/get-excel-file';
import { GetExcelFile$Params } from '../fn/tunnel-section-controller/get-excel-file';
import { getFullExcelFile } from '../fn/tunnel-section-controller/get-full-excel-file';
import { GetFullExcelFile$Params } from '../fn/tunnel-section-controller/get-full-excel-file';
import { getTunnelSection } from '../fn/tunnel-section-controller/get-tunnel-section';
import { GetTunnelSection$Params } from '../fn/tunnel-section-controller/get-tunnel-section';
import { getTunnelSections } from '../fn/tunnel-section-controller/get-tunnel-sections';
import { GetTunnelSections$Params } from '../fn/tunnel-section-controller/get-tunnel-sections';
import { getTunnelSectionsFiltered } from '../fn/tunnel-section-controller/get-tunnel-sections-filtered';
import { GetTunnelSectionsFiltered$Params } from '../fn/tunnel-section-controller/get-tunnel-sections-filtered';
import { PageTunnelSectionDto } from '../models/page-tunnel-section-dto';
import { TunnelSectionDto } from '../models/tunnel-section-dto';
import { updateTunnelSection } from '../fn/tunnel-section-controller/update-tunnel-section';
import { UpdateTunnelSection$Params } from '../fn/tunnel-section-controller/update-tunnel-section';

@Injectable({ providedIn: 'root' })
export class TunnelSectionControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTunnelSection()` */
  static readonly GetTunnelSectionPath = '/v1/tunnelsections/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTunnelSection()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTunnelSection$Response(params: GetTunnelSection$Params, context?: HttpContext): Observable<StrictHttpResponse<TunnelSectionDto>> {
    return getTunnelSection(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTunnelSection$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTunnelSection(params: GetTunnelSection$Params, context?: HttpContext): Observable<TunnelSectionDto> {
    return this.getTunnelSection$Response(params, context).pipe(
      map((r: StrictHttpResponse<TunnelSectionDto>): TunnelSectionDto => r.body)
    );
  }

  /** Path part for operation `updateTunnelSection()` */
  static readonly UpdateTunnelSectionPath = '/v1/tunnelsections/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTunnelSection()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTunnelSection$Response(params: UpdateTunnelSection$Params, context?: HttpContext): Observable<StrictHttpResponse<TunnelSectionDto>> {
    return updateTunnelSection(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTunnelSection$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTunnelSection(params: UpdateTunnelSection$Params, context?: HttpContext): Observable<TunnelSectionDto> {
    return this.updateTunnelSection$Response(params, context).pipe(
      map((r: StrictHttpResponse<TunnelSectionDto>): TunnelSectionDto => r.body)
    );
  }

  /** Path part for operation `deleteTunnelSection()` */
  static readonly DeleteTunnelSectionPath = '/v1/tunnelsections/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTunnelSection()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTunnelSection$Response(params: DeleteTunnelSection$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTunnelSection(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTunnelSection$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTunnelSection(params: DeleteTunnelSection$Params, context?: HttpContext): Observable<void> {
    return this.deleteTunnelSection$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `calculateAll()` */
  static readonly CalculateAllPath = '/v1/tunnelsections/calculateAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculateAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculateAll$Response(params?: CalculateAll$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return calculateAll(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculateAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculateAll(params?: CalculateAll$Params, context?: HttpContext): Observable<void> {
    return this.calculateAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `calculate()` */
  static readonly CalculatePath = '/v1/tunnelsections/calculate/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculate()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculate$Response(params: Calculate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return calculate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculate(params: Calculate$Params, context?: HttpContext): Observable<void> {
    return this.calculate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTunnelSections()` */
  static readonly GetTunnelSectionsPath = '/v1/tunnelsections';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTunnelSections()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTunnelSections$Response(params?: GetTunnelSections$Params, context?: HttpContext): Observable<StrictHttpResponse<PageTunnelSectionDto>> {
    return getTunnelSections(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTunnelSections$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTunnelSections(params?: GetTunnelSections$Params, context?: HttpContext): Observable<PageTunnelSectionDto> {
    return this.getTunnelSections$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageTunnelSectionDto>): PageTunnelSectionDto => r.body)
    );
  }

  /** Path part for operation `createTunnelSection()` */
  static readonly CreateTunnelSectionPath = '/v1/tunnelsections';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTunnelSection()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTunnelSection$Response(params: CreateTunnelSection$Params, context?: HttpContext): Observable<StrictHttpResponse<TunnelSectionDto>> {
    return createTunnelSection(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTunnelSection$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTunnelSection(params: CreateTunnelSection$Params, context?: HttpContext): Observable<TunnelSectionDto> {
    return this.createTunnelSection$Response(params, context).pipe(
      map((r: StrictHttpResponse<TunnelSectionDto>): TunnelSectionDto => r.body)
    );
  }

  /** Path part for operation `getTunnelSectionsFiltered()` */
  static readonly GetTunnelSectionsFilteredPath = '/v1/tunnelsections/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTunnelSectionsFiltered()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTunnelSectionsFiltered$Response(params: GetTunnelSectionsFiltered$Params, context?: HttpContext): Observable<StrictHttpResponse<PageTunnelSectionDto>> {
    return getTunnelSectionsFiltered(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTunnelSectionsFiltered$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTunnelSectionsFiltered(params: GetTunnelSectionsFiltered$Params, context?: HttpContext): Observable<PageTunnelSectionDto> {
    return this.getTunnelSectionsFiltered$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageTunnelSectionDto>): PageTunnelSectionDto => r.body)
    );
  }

  /** Path part for operation `getFullExcelFile()` */
  static readonly GetFullExcelFilePath = '/v1/tunnelsections/fullExcelFile/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFullExcelFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFullExcelFile$Response(params: GetFullExcelFile$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return getFullExcelFile(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFullExcelFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFullExcelFile(params: GetFullExcelFile$Params, context?: HttpContext): Observable<Blob> {
    return this.getFullExcelFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getExcelFile()` */
  static readonly GetExcelFilePath = '/v1/tunnelsections/excelFile/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExcelFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExcelFile$Response(params: GetExcelFile$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return getExcelFile(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExcelFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExcelFile(params: GetExcelFile$Params, context?: HttpContext): Observable<Blob> {
    return this.getExcelFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
